export default {
  title: 'ToDos',
};
